import { defineCapability } from './internal';
import { args } from '../common/args';
export const UPDATE_BELL_ICON_COUNT_CAP = defineCapability({
  name: 'UPDATE_BELL_ICON_COUNT_CAP',
  args: {
    count: args.number()
  }
});